import { render, staticRenderFns } from "./accountSafe.vue?vue&type=template&id=0a2d970a&scoped=true"
import script from "./accountSafe.vue?vue&type=script&lang=js"
export * from "./accountSafe.vue?vue&type=script&lang=js"
import style0 from "./accountSafe.vue?vue&type=style&index=0&id=0a2d970a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d970a",
  null
  
)

export default component.exports